import { render, staticRenderFns } from "./FormDetail.vue?vue&type=template&id=74e45392&"
import script from "./FormDetail.vue?vue&type=script&lang=js&"
export * from "./FormDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74e45392')) {
      api.createRecord('74e45392', component.options)
    } else {
      api.reload('74e45392', component.options)
    }
    module.hot.accept("./FormDetail.vue?vue&type=template&id=74e45392&", function () {
      api.rerender('74e45392', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/intimidation-form/handling/FormDetail.vue"
export default component.exports